import { FlowContext } from 'src/lib/flow';
import { FlowPage } from 'src/lib/flow/FlowPage';
import { FlowQuestion } from 'src/lib/flow/FlowQuestion';
import { areYou } from 'src/lib/flow/text';

function isEnabled({ answers, inputContext: { inApp } }: FlowContext) {
  return !inApp && answers['seller.working_with_home_builder'] == true;
}

const homebuilderNamePage: FlowPage = {
  slug: () => 'home-builder-name',
  title: ({ answers, inputContext: { channel } }) =>
    `Which homebuilder ${areYou(answers, channel)} working with?`,
  autoAdvance: () => false,
  isEnabled,
  questions: (): FlowQuestion[] => [
    {
      key: 'seller.home_builder',
      type: 'combo_input',
      optional: true,
      placeholder: 'Select or search...',
      optionsDataSource: 'builder_partners',
    },
  ],
};

export default homebuilderNamePage;
